export function formatMileage(amount: number) {
  return amount.toLocaleString("en-US", {
    style: "unit",
    unit: "mile",
    unitDisplay: "long",
    maximumFractionDigits: 3,
  });
}
